module.exports = __webpack_public_path__ + "static/media/LancetIDArticle.9c54a7db.png";